"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tooltipTheme = void 0;
var _ChartTooltipModule = _interopRequireDefault(require("./ChartTooltip.module.css"));
var _typographyModule = _interopRequireDefault(require("../../../styles/typography.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const tooltipTheme = exports.tooltipTheme = {
  headerFormat: `<span class="${_typographyModule.default.bodySmall} ${_ChartTooltipModule.default.tooltipHeader}">{point.key}</span>`,
  pointFormat: `<span class=${_ChartTooltipModule.default.tooltipPoint}>
      <span style="background-color:{point.color};" class=${_ChartTooltipModule.default.indicatorCircle}></span>
      <span class="${_ChartTooltipModule.default.tooltipContent} ${_typographyModule.default.bodyMedium}"> {series.name}: {point.y}</span>
    </span>`
};